import React from 'react'
import styles from './styles.module.scss'
import '@/src/extensions/string'

interface Props {
  document: string
  companyName: string
}

export default function DetailsCard({ document, companyName }: Props) {
  if (!document?.isValidCNPJ()) return null

  return (
    <div className={styles.contentDetails}>
      <p>Razão Social: {companyName}</p>
      <p>CNPJ: {document}</p>
    </div>
  )
}
